import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image'
import { AccountContext, GameConfigContext, GamePlayerContext } from '../../context/game-context';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect, useContext } from 'react';
import AccountComponent from './account-component';
import { SocketContext } from '../player-component/context/socket-context';
import { AccountLogin } from './account-login';
import { AccountRegister } from './account-register';
import { useAuthBasicService } from '../../../blockhain/provider/initiate.provider';
import { AccountForgotPassword } from './account-forgot-password';

export default function LandingPage({ setLoading, activateGuestFlow, activateUserLoggedInFlow }) {

    const { sceneConfig } = useContext(SocketContext);
    // const setLoading = GameConfigContext((state) => state.setLoading);
    const [showLanding, setShowLanding] = useState(false);
    const [showTnc, setShowTnc] = useState(false);
    const [currentStep, setCurrentStep] = useState('login');

    const {
        isAuthenticated,
    } = useAuthBasicService();

    useEffect(() => {


        const bearer = localStorage.getItem(`BEARER`);
        if (sceneConfig.autoIngame && !bearer) {
            // playAsGuest();
            setShowLanding(true);
            setLoading(false, null)
        } else {
            setLoading(false, null)
        }

        console.log(sceneConfig.autoIngame, !bearer);

        const modalSub = AccountContext.subscribe(state => state.showLogin, (data) => {
            setShow(data);
        })

        return () => {
            modalSub();
        }
    }, [])


    useEffect(() => {
        if (isAuthenticated) {
            setShowLanding(false);
            activateUserLoggedInFlow();
            // add your logic here
            // console.log(isAuthenticated, "EFFECT AUTHENTICATED CHANGED")
        } else {
            // setUserLogged(null)
        }

    }, [isAuthenticated]);

    const [show, setShow] = useState(false);
    const setShowLogin = AccountContext((state) => state.setShowLogin);
    const gameContext = GamePlayerContext((state) => state.setGamePlayerContext);
    const setIsPlayAsGuest = GamePlayerContext((state) => state.setIsPlayAsGuest);

    const playAsGuest = () => {
        // setLoading(true, null)
        setShowLanding(false)
        activateGuestFlow();
        setIsPlayAsGuest(true)
        // gameContext({ isPlayAsGuest: true })
    }

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setShowLogin(false);
    }

    const handleCloseTnc = () => {
        setShowTnc(false);
    }

    return (
        showLanding ? <>
            <Modal
                show={show}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{isAuthenticated ? "Account" : "Login to Bind Account"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AccountComponent />
                </Modal.Body>
            </Modal>

            <Modal
                show={showTnc}
                onHide={handleCloseTnc}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title>Term & Condition</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    <h6 align="center" className='mb-3'>SYARAT DAN KETENTUAN REGISTRASI UT MUVI</h6>

                    <p>

                        <b>PERJANJIAN
                            PENGGUNAAN LAYANAN UT MUSEUM VIRTUAL</b>

                    </p>
                    <p align="justify" className={"lh-base"}>
                        Perjanjian Penggunaan Layanan UT Museum Virtual(“Perjanjian”)
                        antara pengguna sebagai pihak yang menggunakan Situs UT Museum
                        Virtual dan aplikasi UT MuVi (“Pengguna”) dan PT United Tractors
                        Tbk (“UT”) sebagai pengelola situs dan aplikasi UT MuVi, memuat
                        syarat-syarat dan ketentuan penggunaan layanan situs <u><a
                            href="https://museumvirtual.unitedtractors.com/">https://museumvirtual.unitedtractors.com</a></u> dan
                        aplikasi UT MuVi (“UT MuVi”) <u><a
                            href="https://play-museumvirtual.unitedtractors.com/">https://play-museumvirtual.unitedtractors.com</a></u> yang berlaku bagi Pengguna untuk dapat menggunakan UT MuVi.
                    </p>
                    <p align="justify" className={"lh-base"}>UT
                        selanjutnya dapat disebut juga dengan istilah “Kami”. Mohon untuk
                        membaca dengan hati-hati Perjanjian ini. Anda harus membaca,
                        memahami, menerima dan menyetujui semua persyaratan dan ketentuan
                        dalam Perjanjian ini sebelum menggunakan aplikasi dan/atau menerima
                        konten yang terdapat di dalamnya.</p>
                    <p align="justify" className={"lh-base"}>Dengan menggunakan aplikasi
                        dan/atau melanjutkan akses terhadap UT MuVi, Pengguna menyetujui
                        seluruh persyaratan dan ketentuan yang terdapat di dalamnya, dan oleh
                        karena itu menyetujui untuk terikat dalam suatu Perjanjian dengan
                        Kami dan oleh karenanya Anda menyatakan persetujuan untuk dapat
                        menerima layanan dan akses atas seluruh konten yang terdapat dalam UT
                        MuVi. </p>
                    <p align="justify" className={"lh-base"}>Jika Anda tidak menerima dan menyetujui salah satu, sebagian
                        atau seluruh isi dari syarat dan ketentuan di Perjanjian ini,
                        Pengguna tidak diperkenankan untuk mengakses lebih lanjut dan
                        dipersilakan untuk meninggalkan UT MuVi.
                    </p>
                    <p align="justify" className={"lh-base"}>Setiap kegiatan terkait
                        dengan penggunaan UT MuVi maka baik Kami dan Pengguna dilindungi
                        secara hukum melalui ketentuan peraturan perundangan – undangan
                        yang berlaku termasuk namun tidak terbatas pada peraturan tentang
                        Informasi dan Transaksi Elektronik dan Hak Kekayaan Intelektual, dan
                        terhadap segala bentuk perikatan yang timbul dari segala aktivitas di
                        UT MuVi telah memenuhi kaidah dan syarat sahnya suatu perikatan
                        sebagaimana yang tercantum dalam Kitab Undang-Undang Hukum Perdata
                        Indonesia.
                    </p>
                    <ol>
                        <li>
                            <p align="justify">
                                <b>PENDAHULUAN</b>
                            </p>
                            <ul className={"list-group"} style={{ listStyleType: "none" }}>

                                <li><p align="justify" className={"lh-base"}>
                                    1.1 Perjanjian ini diatur dan
                                    diinterprestasikan berdasarkan Hukum Republik Indonesia (Indonesia).
                                    Pihak-pihak yang disebutkan dalam Perjanjian dengan ini sepakat untuk
                                    tunduk kepada pengadilan di Indonesia.
                                </p></li>
                                <li><p align="justify" className={"lh-base"}>
                                    1.2 Dalam Perjanjian ini yang
                                    dimaksud dengan “Pengguna” adalah orang perseorangan, baik warga
                                    negara Indonesia, maupun badan hukum dengan kemampuan menggunakan
                                    komputer, jaringan, komputer dan/atau media elektronik lainnya yang
                                    mampu untuk mengakses UT MuVi sesuai dengan keperluannya dan telah
                                    membuat sebuah nama akun (username) dan sandi (password).
                                </p></li>
                                <li><p align="justify" className={"lh-base"}>
                                    1.3 Pengguna Terdaftar (
                                    <i>verified
                                        member</i>
                                    ) adalah
                                    Pengguna yang telah terdaftar dalam Sistem internal yang dimiliki
                                    oleh UT. Pengguna dan Pengguna Terdaftar selanjutnya disebut sebagai
                                    “Pengguna”.
                                </p></li>
                                <li><p align="justify" className={"lh-base"}>
                                    1.4 Dengan mengakses atau
                                    menggunakan UT MuVi, Pengguna yang termasuk dalam kategori Pengguna
                                    sebagaimana disebutkan dalam poin 1.2 dan 1.3 di atas secara sadar
                                    dan tanpa paksaan dari pihak manapun menyatakan diri setuju untuk
                                    menerima semua syarat dan ketentuan yang tercantum dalam Perjanjian
                                    ini serta ketentuan-ketentuan lainnya yang berlaku di UT MuVi.
                                    Sebagai Pengguna, Pengguna terikat dengan syarat dan ketentuan dalam
                                    Perjanjian yang berlaku dalam hal Pengguna mengakses atau menggunakan
                                    UT MuVi.
                                </p></li>
                                <li><p align="justify" className={"lh-base"}>
                                    1.5 Perjanjian ini mungkin dapat
                                    diubah dan/atau diperbaharui setiap waktu dan Kami akan mencantumkan
                                    Perjanjian yang telah diubah atau diperbarui di dalam UT MuVi.
                                    Persyaratan dan ketentuan yang telah diubah dan diperbarui akan
                                    segera berlaku setelah persyaratan dan ketentuan yang telah diubah
                                    dan diperbarui dicantumkan di UT MuVi, dan Pengguna diwajibkan untuk
                                    membaca syarat dan ketentuan dalam Perjanjian dari waktu ke waktu
                                    karena Perjanjian ini dapat berubah sewaktu waktu tanpa adanya
                                    pemberitahuan kepada Pengguna. Dengan tetap mengakses dan menggunakan
                                    UT MuVi, Pengguna setuju atas perubahan–perubahan dalam syarat dan
                                    ketentuan ini.
                                </p></li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>KETENTUAN
                                    UMUM BAGI PENGGUNA</b>

                            </p>
                            <ul className={"list-group"} style={{ listStyleType: "none" }}>
                                <li><p align="justify">
                                    2.1 Pengguna dengan ini
                                    menyatakan bahwa Pengguna adalah subjek hukum yang cakap dan mampu
                                    untuk mengikatkan diri dalam Perjanjian.
                                </p>
                                </li>
                                <li><p align="justify">
                                    2.2 Setiap pengguna tidak
                                    diperbolehkan mengambil isi UT MuVi secara sistematis untuk membuat
                                    atau menyusun, baik secara langsung maupun tidak langsung, koleksi,
                                    kompilasi, database atau direktori (baik menggunakan perangkat
                                    otomatis ataupun proses manual) tanpa izin tertulis dari Kami. Selain
                                    itu Pengguna tidak diperkenankan menggunakan isi atau bahan tersebut
                                    di atas untuk tujuan apa pun yang tidak disebutkan di dalam
                                    Perjanjian ini.
                                </p></li>
                                <li>
                                    <p align="justify">
                                        2.3 Saat mengunjungi dan
                                        menggunakan UT MuVi, termasuk setiap fitur dan layanannya, setiap
                                        Pengguna tidak diperkenankan untuk:
                                    </p>
                                    <ul className='list-unstyled ps-4'>
                                        <li>
                                            <p align="justify" className='mb-2'>1. Memberikan informasi dan
                                                konten yang salah, tidak akurat, bersifat menyesatkan, bersifat
                                                memfitnah, bersifat asusila, mengandung pornografi, bersifat
                                                diskriminasi atau rasis.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>2. Menggunakan data, informasi, dan
                                                akun-akun yang tidak benar dan yang bersifat sementara
                                                (temporary/disposable) dalam akun Pengguna Terdaftar.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>3. Mengambil
                                                tindakan yang dapat mengacaukan sistem
                                                <i>chat</i>

                                                dan atau peringkat (seperti menampilkan, mengimpor atau mengekspor
                                                informasi atau masukan dari situs luar atau menggunakannya untuk
                                                tujuan yang tidak terkait dengan UT MuVi).
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>4. Memberikan atau
                                                mencantumkan nama akun dan/atau
                                                <i>password</i>

                                                miliknya di UT MuVi (termasuk pada kolom
                                                <i>chat</i>
                                                )
                                                atau kepada pihak lain.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>5. Menyebarkan spam, hal-hal yang bersifat
                                                asusila, atau pesan elektronik yang berjumlah besar, pesan
                                                bersambung.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>6. Menyebarkan virus atau seluruh teknologi lainnya yang
                                                sejenis yang dapat merusak dan/atau merugikan UT MuVi, afiliasinya
                                                dan pengguna lainnya.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>7. Memasukkan atau memindahkan fitur pada UT
                                                MuVi tidak terkecuali tanpa sepengetahuan dan persetujuan dari Kami.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>8. Mengubah atau menyebarkan konten dan fitur UT MuVi, termasuk cara
                                                pelayanan, konten, hak cipta dan intelektual yang terdapat pada UT
                                                MuVi tanpa menyertakan sumbernya.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify">9. Mengambil atau mengumpulkan
                                                informasi dari pengguna lain, termasuk alamat email, tanpa
                                                sepengetahuan pengguna lain.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                                <li><p align="justify">
                                    2.4 Kami berhak membatasi atau
                                    tidak memberikan akses untuk dapat membuka UT MuVi dan fitur di
                                    dalamnya kepada Pengguna, atau mengganti salah satu fitur atau
                                    memasukkan fitur baru tanpa pemberitahuan sebelumnya. Setiap Pengguna
                                    dengan ini sepakat bahwa karena alasan apapun membebaskan Kami dari
                                    segala bentuk pertanggungjawaban terhadap Pengguna atau terhadap
                                    pihak ketiga jika yang bersangkutan tidak dapat menggunakan UT MuVi
                                    (baik karena gangguan, dibatasinya akses, dilakukannya perubahan
                                    fitur atau tidak dimasukkannya lagi fitur tertentu atau karena alasan
                                    lain); atau jika komunikasi atau transmisi tertunda, gagal atau tidak
                                    dapat berlangsung; atau jika timbul kerugian (secara langsung, tidak
                                    langsung) karena digunakannya atau tidak dapat digunakannya UT MuVi
                                    atau salah satu fitur di dalamnya.
                                </p></li>
                                <li><p align="justify">
                                    2.5 Dengan terus melakukan akses
                                    atau terus menggunakan UT MuVi, Pengguna dianggap telah membaca,
                                    memahami dan menyetujui ketentuan UT MuVi tentang Ketentuan dan
                                    Kebijakan Privasi yang diatur dalam Pasal 9 dari Perjanjian
                                    Penggunaan Layanan UT MuVi ini yang mengatur masalah penggunaan
                                    informasi yang dimasukkan masing-masing Pengguna ke dalam UT MuVi.
                                    Pengguna menerima ketentuan ini serta tambahan atau setiap perubahan
                                    atau pembaruannya. Pengguna memahami dan mengetahui secara sadar
                                    bahwa Kami dapat mengubah ketentuan tentang Kebijakan Privasi ini
                                    sewaktu-waktu dan akan memasukkan versi terbarunya di UT MuVi.
                                </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>PENGGUNA
                                    TERDAFTAR</b>

                            </p>
                            <ul className={"list-unstyled"}>
                                <li>
                                    <p align="justify">
                                        3.1. Dengan memilih untuk membuat
                                        akun sebagai Pengguna dari UT MuVi, Pengguna akan membuat sebuah nama
                                        akun (
                                        <i>username</i>
                                        )
                                        dan sandi (
                                        <i>password</i>
                                        )
                                        ketika menyelesaikan proses registrasi dan verifikasi yang telah
                                        ditetapkan dalam UT MuVi.
                                    </p>
                                </li>
                                <li>
                                    <p align="justify">
                                        3.2. Pengguna bertanggung jawab
                                        untuk menjaga kerahasiaan dan keamanan atas alamat email dan password
                                        serta bertanggung jawab sepenuhnya atas segala kegiatan yang
                                        dilakukan oleh atau diatasnamakan Alamat email akun Pengguna.
                                    </p>
                                </li>
                                <li>
                                    <p align="justify">
                                        3.3. Pengguna menyetujui untuk:

                                    </p>
                                    <ul className={"list-unstyled ps-3"} >
                                        <li>
                                            <p align="justify">3.3.1 Segera memberitahukan kepada Kami setiap adanya dugaan
                                                penggunaan yang tidak sah/valid dengan pengatasnamaan nama akun
                                                Pengguna terdaftar.</p>
                                        </li>
                                        <li>
                                            <p align="justify">3.3.2 Memastikan bahwa Pengguna Terdaftar keluar
                                                (log out) dari akun pada setiap akhir dari aktivitas di UT MuVi untuk
                                                menghindari kemungkinan terjadinya penyalahgunaan atas akun yang
                                                bersangkutan. </p>
                                        </li>
                                        <li>
                                            <p align="justify">3.3.3. Memberikan persetujuan kepada UT, selama
                                                Pengguna terdaftar dalam UT MuVi, untuk mengirimkan, menyebarluaskan
                                                dan memberikan setiap informasi, promosi, pemberitahuan, brosur dan
                                                segala bentuk komunikasi melalui data pribadi Pengguna yang terdaftar
                                                dalam UT MuVi.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>HAK
                                    DAN KEWAJIBAN PENGGUNA</b>

                            </p>

                            <ul className='list-unstyled'>
                                <li>
                                    <p align="justify">
                                        4.1. Setiap Pengguna bertanggung
                                        jawab atas seluruh hal atau kegiatan yang dilakukan di UT MuVi atas
                                        nama Pengguna atau menggunakan akun Pengguna tersebut.
                                    </p>
                                </li>
                                <li>
                                    <p align="justify">
                                        4.2. Setiap Pengguna bertanggung
                                        jawab sepenuhnya jika Pengguna melakukan pelanggaran terhadap
                                        ketentuan-ketentuan yang telah dirincikan pada Perjanjian ini, dan
                                        menyetujui untuk melepaskan Kami beserta afiliasinya atas seluruh
                                        kerugian yang diakibatkan oleh pelanggaran yang dilakukan oleh
                                        Pengguna.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>

                                <b>PEMBATASAN
                                    TANGGUNG JAWAB KAMI</b>

                            </p>

                            <ul className='list-unstyled'>

                                <li>
                                    <p>
                                        5.1. Kewajiban Kami hanyalah
                                        sebatas pada penyediaan UT MuVi.
                                    </p>
                                </li>

                                <li>
                                    <p>
                                        5.2. Bentuk kerugian yang
                                        dikarenakan dari tindakan Pengguna yang melanggar Perjanjian ini
                                        sepenuhnya adalah tanggung jawab Pengguna di mana Pengguna melepaskan
                                        kami dari segala bentuk tanggung jawab, gugatan atau tuntutan
                                        pihak-pihak yang dirugikan.
                                    </p>
                                </li>

                                <li>
                                    <p>
                                        5.3. Materi yang ditayangkan di
                                        UT MuVi disediakan tanpa ketentuan atau jaminan apapun dalam hal
                                        ketepatannya. Sejauh diijinkan oleh hukum, Kami dan para pihak ketiga
                                        yang berhubungan dengan Kami dengan ini secara tegas mengecualikan:
                                        Semua ketentuan, jaminan dan syarat lain yang dapat dinyatakan secara
                                        tidak langsung oleh undang-undang, hukum adat atau hukum keadilan.
                                    </p>
                                </li>

                                <li>
                                    <p>
                                        5.4. Materi yang ditayangkan di
                                        UT MuVi adalah untuk informasi saja guna membantu Pengguna dalam
                                        mengetahui sejarah berdiri, produk yang dijual dan program
                                        keberlangsungan PT United Tractors, Tbk dengan tatap muka dan
                                        pengalaman yang lebih unik.
                                    </p>
                                </li>

                                <li>
                                    <p>
                                        5.5. Kami memiliki hak untuk
                                        kapan saja menampilkan, mengubah, menghapus, menghilangkan, atau
                                        menambahkan segala konten yang ditampilkan dalam UT MuVi.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>HAK
                                    MILIK INTELEKTUAL</b>

                            </p>
                            <ul className='list-unstyled'>
                                <li>
                                    <p align="justify">
                                        Kami adalah pemilik tunggal atau
                                        pemegang sah semua hak atas dan isi dalam UT MuVi. UT MuVi dan isinya
                                        mencakup hak milik intelektual yang dilindungi oleh undang-undang hak
                                        cipta dan undang-undang yang melindungi kekayaan intelektual lainnya
                                        yang berlaku di seluruh dunia. Semua hak milik dan hak milik
                                        intelektual atas UT MuVi dan isinya tetap pada Kami, afiliasinya atau
                                        pemilik lisensi isi UT MuVi.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>PEMBAHARUAN</b>

                            </p>
                            <ul className='list-unstyled'>
                                <li>
                                    <p align="justify">
                                        Pengguna memahami bahwa Kami
                                        sewaktu–waktu dapat melakukan perubahan (pengurangan atau
                                        penambahan) ketentuan dalam Perjanjian ini. Kami menyarankan agar
                                        Pengguna secara berkala dan seksama melihat Perjanjian ini. Dengan
                                        tetap mengakses dan/atau menggunakan UT MuVi, maka Pengguna dianggap
                                        telah menyetujui perubahan–perubahan dalam kebijakan privasi ini.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>PILIHAN
                                    HUKUM &amp; PENYELESAIAN PERSELISIHAN</b>

                            </p>
                            <ul className='list-unstyled'>
                                <li>
                                    <p align="justify">
                                        Perjanjian ini diatur dan
                                        ditafsirkan serta tunduk berdasarkan Hukum Indonesia. Segala
                                        perselisihan yang mungkin timbul antara Pengguna dengan Kami
                                        sehubungan dengan penggunakan UT MuVi dan/atau pelaksanaan Perjanjian
                                        ini akan diselesaikan melalui Pengadilan Negeri Jakarta Timur.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>KETENTUAN
                                    DAN KEBIJAKAN PRIVASI</b>
                            </p>
                            <ul className='list-unstyled'>
                                <li>
                                    <p align="justify">
                                        9.1. Lingkup Kebijakan Privasi
                                    </p>
                                    <ul className='list-unstyled ps-4'>
                                        <li>
                                            <p align="justify">
                                                9.1.1. Kebijakan Privasi ini menetapkan cara melindungi dan
                                                menggunakan informasi yang Pengguna berikan ketika menggunakan
                                                layanan situs ini.</p>
                                        </li>
                                        <li>
                                            <p align="justify"> 9.1.2. Kami berkomitmen untuk memastikan bahwa
                                                privasi Pengguna dilindungi. BilaKami meminta Pengguna untuk
                                                memberikan informasi tertentu yang dapat diidentifikasi ketika
                                                menggunakan website ini, maka informasi tersebut itu hanyaakan
                                                digunakan sesuai dengan pernyataan privasi ini.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify">9.1.3. Kami dapat
                                                mengubah Kebijakan Privasi ini dari waktu ke waktu dengan melakukan
                                                pengurangan ataupun penambahan ketentuan pada halaman ini. Perubahan
                                                terhadap kebijakan ini akan diumumkan melalui
                                                <a href="https://museumvirtual.unitedtractors.com/" className='mx-2'>
                                                    https://museumvirtual.unitedtractors.com
                                                </a>

                                                atau melalui media lainnya. Pengguna diharapkan untuk memeriksa
                                                halaman ini secara berkala agar Pengguna mengetahui
                                                perubahan-perubahan tersebut. Dengan tetap mengakses dan menggunakan
                                                layanan pada aplikasi UT MuVi, Pengguna dianggap telah menyetujui
                                                perubahan-perubahan ketentuan pada Kebijakan Privasi ini.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p align="justify">
                                        9.2. Informasi yang Kami minta di
                                        aplikasi UT MuVi.
                                    </p>
                                    <ul className='list-unstyled ps-4'>
                                        <li><p align="justify">9.2.1. Informasi mengenai identitas diri yang Kami
                                            dapat secara sukarela dari Pengguna melalui aplikasi UT MuVi adalah :</p></li>
                                        <ul className='list-unstyled ps-4'>
                                            <li><p align="justify" className='mb-2'>9.2.1.1. Nama Lengkap Perorangan;</p></li>
                                            <li><p align="justify" className='mb-2'>9.2.1.2. Alamat Surat elektronik(email);</p> </li>
                                            <li><p align="justify" className='mb-2'>9.2.1.3. Usia Pengguna;</p></li>
                                            <li><p align="justify">9.2.1.4. Jenis Kelamin;</p></li>
                                        </ul>
                                        <li>
                                            <p align="justify">9.2.2. Kami
                                                mengasumsikan bahwa semua informasi dan perubahan-perubahan yang
                                                Pengguna berikan di atas sekarang, atau di masa yang akan datang
                                                adalah akurat dan benar. Apabila informasi dan perubahan-perubahan
                                                yang Pengguna berikan tersebut ternyata terbukti tidak benar, maka
                                                dengan ini Kami menyatakan tidak bertanggung jawab atas segala akibat
                                                yang dapat terjadi sehubungan dengan pemberian informasi dan
                                                perubahan-perubahan yang tidak benar tersebut.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p align="justify">
                                        9.3. Penggunaan Informasi. Kami
                                        menggunakan informasi yang dimaksud dalam pasal 9.2.1 di atas untuk :
                                    </p>
                                    <ul className='list-unstyled ps-4'>
                                        <li>
                                            <p align="justify" className='mb-2'>
                                                9.3.1. Kepentingan riset dan demografi Pengguna;
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>9.3.2. Kepentingan
                                                pengembangan aplikasi UT MuVi;
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'> 9.3.3. Memberikan
                                                informasi/mengirimkan promosi atas fitur-fitur baru atau informasi
                                                lain yang Kami anggap Pengguna perlukan di aplikasi UT MuVi;
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify" className='mb-2'>9.3.4.
                                                Mengumpulkan data interaksi antara Pengguna dan UT MuVi termasuk
                                                informasi mengenai penggunaan Pengguna terhadap fitur–fitur dan
                                                layanan yang Kami sediakan; dan
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify">9.3.5. Catatan internal/administrasi
                                                Kami.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p align="justify">
                                        9.4. Keamanan Informasi. Kami
                                        berkomitmen untuk memastikan bahwa informasi yang Pengguna berikan
                                        kepada Kami dalam keadaan aman. Untuk mencegah akses tidak sah, Kami
                                        melakukan tindakan pengamanan fisik, elektronik, dan prosedur
                                        manajerial yang diperlukan untuk melindungi informasi Pengguna yang
                                        Kami kumpulkan secara online.
                                    </p>
                                </li>
                                <li>
                                    <p align="justify">
                                        9.5. Koneksi Ke Website Lain
                                    </p>
                                    <ul className='list-unstyled ps-4'>
                                        <li>
                                            <p align="justify" className='mb-2'>
                                                9.5.1. Untuk keperluan referensi dan kenyamanan Pengguna, Website
                                                Kami mungkin menyediakan link ke situs-situs lain. Namun, ketika
                                                Pengguna menggunakan link–link ini, Kami tidak bertanggung jawab
                                                untuk melindungi privasi dan informasi apapun yang Pengguna berikan
                                                ketika mengunjungi situs-situs tersebut karena Kami tidak mengetahui
                                                kebijakan penanganan informasi pribadi di situs-situs sebagaimana
                                                dimaksud dan tidak bertanggung jawab atas konten mereka. Pengguna
                                                harus berhati-hati, mempelajari dan melihat pernyataan privasi yang
                                                berlaku di situs tersebut.
                                            </p>
                                        </li>
                                        <li>
                                            <p align="justify">9.5.2. Entitas apapun yang Pengguna pilih
                                                sebagai kontak atau berinteraksi baik yang terdaftar dalam direktori
                                                ataupun di tempat lain selain dari Aplikasi UT MuVi, adalah
                                                sepenuhnya tanggung jawab layanan tersebut pada Pengguna, dan
                                                Pengguna setuju bahwa Aplikasi UT MuVi tidak dapat dikenakan tindakan
                                                apapun untuk kerusakan atau biaya yang keluar atas interaksi yang
                                                terjadi antara Pengguna dengan layanan yang bersangkutan.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p align="justify">
                                        9.6. Pendistribusian informasipribadi Pengguna
                                    </p>
                                    <ul className='list-unstyled ps-4'>
                                        <li>
                                            <p align="justify" className='mb-2'>
                                                9.6.1. Kami tidak akan menjual, mendistribusikan
                                                atau menyewakan informasi pribadi Pengguna kepada pihak ketiga,
                                                kecuali terbatas untuk hal-hal sebagai berikut:
                                            </p>
                                            <ul className='list-unstyled ps-4'>
                                                <li>
                                                    <p align="justify" className='mb-2'>9.6.1.1. Apabila
                                                        diharuskan oleh hukum dan peraturan perundang-undangan yang berlaku
                                                        di Republik Indonesia;
                                                    </p>
                                                </li>
                                                <li>
                                                    <p align="justify" className='mb-2'>9.6.1.2. Apabila diperlukan oleh mitra Kami
                                                        dalam rangka melaksanakan pekerjaannya seperti analisa data, layanan
                                                        bantuan, peningkatan sistem keamanan dan privasi, serta peningkatan
                                                        dan pengembangan aplikasi UT MuVi.
                                                    </p>
                                                </li>
                                                <li>
                                                    <p align="justify" className='mb-2'>9.6.1.3. Apabila terjadi
                                                        pengalihan unit aset atau kepemilikan usaha kepada pihak lain.
                                                    </p>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <p align="justify">
                                                9.6.2.
                                                Selain untuk kepentingan-kepentingan sebagaimana disebutkan di atas,
                                                Pengguna akan menerima pemberitahuan apabila akan terjadi
                                                pendistribusian informasi pribadi Pengguna kepada pihak lain, dan
                                                Pengguna berhak untuk meminta agar informasi pribadi Pengguna tidak
                                                diikutsertakan.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p align="justify">

                                <b>PENUTUP</b>
                            </p>
                            <ul className='list-unstyled'>
                                <li>
                                    <p align="justify">
                                        Dengan menggunakan layanan di UT
                                        MuVi maka Pengguna telah membaca, mengerti, mematuhi dan menyetujui
                                        Perjanjian ini dan seluruh syarat–syarat dan ketentuan–ketentuan
                                        yang berlaku di UT MuVi.
                                    </p>
                                </li>
                            </ul>
                        </li>
                    </ol>

                </Modal.Body >
            </Modal >
            <div className="landing container-fluid">
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className='col-md-6 d-flex justify-content-center'>
                            <div className='card' style={{ maxWidth: '500px' }}>
                                <div className='bg-orange-default py-2'>
                                    <img src='/img/ut-vm-logo.png' style={{ height: '80px' }} />
                                </div>
                                <div className='card-body pt-0'>
                                    <div className='account-login'>
                                        <div className='account-button-list row'>
                                            {currentStep == 'login' && <AccountLogin setCurrentStep={setCurrentStep} playAsGuest={playAsGuest} />}
                                            {currentStep == 'register' && <AccountRegister setCurrentStep={setCurrentStep} setShowTnc={setShowTnc} />}
                                            {currentStep == 'forgot-password' && <AccountForgotPassword setCurrentStep={setCurrentStep} />}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </> : <></>
    )
}